import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: "40%",
      persistent: ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("div", {
    staticClass: "drawer-title"
  }, [_c(VBtn, {
    staticClass: "primary",
    attrs: {
      rounded: "",
      disabled: _vm.isCreating
    },
    on: {
      click: _vm.close
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-close")])], 1), _c("h2", [_vm._v("Create Sign Up Link")])], 1)]), _c(VForm, [_c(VTextField, {
    attrs: {
      label: "Name",
      placeholder: "Link name",
      rules: [_vm.rules.required]
    },
    on: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.createSignupLink.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c(VTextField, {
    attrs: {
      label: "UTM Source, technical unique identifier",
      placeholder: "e.g., email_campaign, social_media",
      rules: [_vm.rules.required]
    },
    on: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.createSignupLink.apply(null, arguments);
      },
      input: _vm.sanitizeUtmSource
    },
    model: {
      value: _vm.form.utmSource,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "utmSource", $$v);
      },
      expression: "form.utmSource"
    }
  }), _vm.isFormValid ? _c("div", {
    staticClass: "link-preview text-smaller mt-4"
  }, [_c("div", {
    staticClass: "preview-label"
  }, [_vm._v("Generated Link:")]), _c("div", {
    staticClass: "preview-link"
  }, [_c("a", {
    attrs: {
      href: _vm.generatedLink,
      target: "_blank"
    }
  }, [_vm._v(_vm._s(_vm.generatedLink))]), _c(VTooltip, {
    attrs: {
      top: ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VIcon, _vm._g(_vm._b({
          staticClass: "ml-2",
          attrs: {
            small: "",
            disabled: _vm.isCopyingToClipboard,
            title: "Copy to clipboard"
          },
          on: {
            click: function click($event) {
              return _vm.copyToClipboard(_vm.generatedLink);
            }
          }
        }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
      }
    }], null, false, 743393919)
  }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
    staticStyle: {
      color: "green"
    }
  }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])], 1)]) : _vm._e()], 1), _c("div", {
    staticClass: "action-add"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.isCreating,
      disabled: !_vm.isFormValid
    },
    on: {
      click: _vm.createSignupLink
    }
  }, [_vm._v(" Create Sign Up Link ")])], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };